import React from "react";

export default function InsuranceProcess({
  title,
  subtitle,
  imageL,
  imageD,
  steps,
}) {
  return (
    <section className=" bg-sidom-blue overflow-hidden">
      <div className="container  mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0">
        <h1 className="text-3xl md:text-[40px] lg:text-[45px] leading-[1.6]  text-sidom-light  mb-30 text-left w-full  ">
          <span
            className="leading-[1.3]"
            dangerouslySetInnerHTML={{ __html: title }}
          />{" "}
          <span className="text-sidom-orange leading-[1.4]  md:text-5xl font-bold">
            {subtitle}
          </span>
        </h1>
        <div className="flex mt-[30px] md:mt-[60px] flex-col lg:flex-row gap-8 items-center ">
          <div className="w-full p-2 lg:w-[60%]">
            {/* <img
              src={imageL}
              className="block dark:hidden w-full h-auto"
              alt="Imagen modo oscuro"
            /> */}

            <img
              src={imageD}
              className="  w-full h-auto"
              alt="Imagen modo claro"
            />
          </div>
          <div className=" w-full mt-[30px] md:mt-[60px] lg:w-[40%] ">
            <ol className="list-decimal text-base pl-5 space-y-4 text-sidom-light">
              {steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
